(function () {
    'use strict';

    angular
        .module('app')
        .factory('lastSearchService', lastSearchService);

    lastSearchService.$inject = ['$http', '$localStorage', '$q', 'breadCrumbService', 'loginService', 'searchService'];

    function lastSearchService($http, $localStorage, $q, breadCrumbService, loginService, searchService) {
        var service = {
            getData: getData,
            getCount: getCount,
            getOperations: getOperations,
            getLastSearchOperations: getLastSearchOperations,
            getLastSearchAllOperations: getLastSearchAllOperations,
            getAllOperations: getAllOperations
        };

        return service;

        // Last Search Service - getData
        function getData(skip, take, totalRecords, sort, sortDirection, countOperation, resultType, columns) {
            var deferred = $q.defer();

            //define objects required for call
            var adeptDataTable = { TableDefinition: null, TableRecords: null, RecordCount: totalRecords, Take: take, Skip: skip };
            var searchObject = {
                SavedSearchID: null,
                UserId: null,
                ColumnSetId: null,
                ResultType: resultType,
                Columns: columns,
                CountOperation: countOperation,
                AdeptDataTable: adeptDataTable,
                Sort: { SortField: sort, SortOrder: sortDirection }
            };

            //breadcrumb

            breadCrumbService.category = loginService.resourceStrings["SEARCH"];

            getLastSearchOperations().then(function (value) {
                breadCrumbService.details = value;
                breadCrumbService.node = null;
            });
            
            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            var request = $http({
                url: '../Synergis.WebApi/Api/lastSearch/documents',
                method: 'POST',
                data: JSON.stringify(searchObject),
                responseType: responseType,
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                deferred.resolve(response);
            }, function (response) {
                deferred.reject(response);
            });

            return { promise: deferred.promise };
        };


        // Last Search Service - getCount
        function getCount() {
            var deferred = $q.defer();
            service.getData(0, 0, 0, "SCHEMA_S_LONGNAME", 0, true).promise.then(function (response) {
                deferred.resolve(response.data.AdeptDataTable.RecordCount);
            });
            return deferred.promise;
        }

        // Last Search Service - getOperations
        function getOperations() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/Api/lastSearch/operations').then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function getAllOperations() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/Api/lastSearch/AltOperations').then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }


        function getLastSearchOperations() {
            var deferred = $q.defer();
            var searchActions = [" ", " [" + loginService.resourceStrings["OR"].toUpperCase() + "] ", " [" + loginService.resourceStrings["AND"].toUpperCase() + "] ", ""];
            service.getOperations().then(function (data) {
                var previousSearchCriteria = "";
                angular.forEach(data, function (operationList, key) {
                    //handle SAF
                    if (operationList.searchAction == 3) {
                        operationList.searchCriteria = [{ schemaID: "__SEARCH_ALL_FIELDS__", valueStr: operationList.searchCriteria[0].valueStr }]
                    }
                    var operations = searchService.parseOperations(operationList.searchCriteria);
                    if (operationList.searchCriteria.length > 0) {
                        previousSearchCriteria = previousSearchCriteria + searchActions[operationList.searchAction] + searchService.parseOperationsToString(operations);
                    }
                });
                deferred.resolve(previousSearchCriteria);
            });
            return deferred.promise;
        }

        function getLastSearchAllOperations() {
            var deferred = $q.defer();
            var searchActions = [" ", " [" + loginService.resourceStrings["OR"].toUpperCase() + "] ", " [" + loginService.resourceStrings["AND"].toUpperCase() + "] ", ""];
            service.getAllOperations().then(function (data) {
                var previousSearchCriteria = "";
                angular.forEach(data, function (operationList, key) {
                    //handle SAF
                    if (operationList.searchAction == 3) {
                        operationList.searchCriteria = [{ schemaID: "__SEARCH_ALL_FIELDS__", valueStr: operationList.searchCriteria[0].valueStr }]
                    }
                    var operations = searchService.parseOperations(operationList.searchCriteria);
                    if (operationList.searchCriteria.length > 0) {
                        previousSearchCriteria = previousSearchCriteria + searchActions[operationList.searchAction] + searchService.parseOperationsToString(operations);
                    }
                });
                deferred.resolve(previousSearchCriteria);
            });
            return deferred.promise;
        }



    }
})();